// frontend/src/components/SkeletonCard.js
import React from 'react';
// No need to import a CSS file here, as it will be imported globally or in a parent component

const SkeletonCard = () => {
    return (
        <div className="skeleton-card">
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
                <div className="skeleton-line skeleton-line-lg"></div> {/* For product name */}
                <div className="skeleton-line skeleton-line-sm"></div> {/* For gram/short description */}
                <div className="skeleton-line skeleton-line-price"></div> {/* For price */}
                <div className="skeleton-button"></div> {/* For button */}
            </div>
        </div>
    );
};

export default SkeletonCard;
